import { Controller } from "@hotwired/stimulus"

export default class ScheduleController extends Controller {
  static targets = ["startHour", "startMin", "endHour", "endMin", "destroyFlag", "destroyButton"]

  static classes = ["hidden", "show"]

  hideDestroyButton() {
    this.destroyButtonTarget.classList.remove(this.showClass)
    this.destroyButtonTarget.classList.add(this.hiddenClass)
  }

  showDestroyButton() {
    this.destroyButtonTarget.classList.remove(this.hiddenClass)
    this.destroyButtonTarget.classList.add(this.showClass)
  }

  destroy() {
    this.startHourTarget.value = null
    this.startMinTarget.value = null
    this.endHourTarget.value = null
    this.endMinTarget.value = null
    this.destroyFlagTarget.value = 'true'
    this.hideDestroyButton()
  }

  toggleDestroyButton() {
    this.startHour = this.startHourTarget.value.trim()
    this.startMin = this.startMinTarget.value.trim()
    this.endHour = this.endHourTarget.value.trim()
    this.endMin = this.endMinTarget.value.trim()

    if (this.startHour || this.startMin || this.endHour || this.endMin) {
      this.showDestroyButton()
    }
    else
    {
      this.hideDestroyButton()
    }
  }
}
